import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { getReadableTypeName } from '../../../utils/PlaceTypeMapping'; // Adjust the path as needed
import '../../../styles/components/itinerary/saved_places/TypeFilter.css';

const TypeFilter = ({ savedPlaces, selectedItinerary, onTypeFilterChange }) => {
  const [allTypes, setAllTypes] = useState([]); // All types state
  const [selectedType, setSelectedType] = useState(''); // Selected type filter state
  const [isDropdownVisible, setIsDropdownVisible] = useState(false); // Dropdown visibility state
  const typeFilterRef = useRef(null); // Reference to the TypeFilter component

  useEffect(() => {
    if (!selectedItinerary) return;
    const itineraryPlaces = savedPlaces[selectedItinerary.id] || [];
    const allTypesSet = new Set();
    itineraryPlaces.forEach(place => {
      place.types?.forEach(type => {
        const readableType = getReadableTypeName(type);
        if (readableType) {
          allTypesSet.add(type);
        }
      });
    });
    const sortedTypes = Array.from(allTypesSet).sort((a, b) => {
      const readableA = getReadableTypeName(a);
      const readableB = getReadableTypeName(b);
      return readableA.localeCompare(readableB);
    });
    setAllTypes(sortedTypes);
  }, [savedPlaces, selectedItinerary]);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const handleTypeClick = (type) => {
    setSelectedType(type);
    onTypeFilterChange(type);
    setIsDropdownVisible(false);
  };

  const handleTypeResetClick = (e) => {
    e.stopPropagation(); // Prevent dropdown toggle
    setSelectedType('');
    onTypeFilterChange('');
  };

  const handleClickOutside = (event) => {
    if (typeFilterRef.current && !typeFilterRef.current.contains(event.target)) {
      setIsDropdownVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="type-filter" ref={typeFilterRef}>
      <div className="type-filter-box" onClick={toggleDropdown}>
        <span className={`type-text ${selectedType ? 'selected' : ''}`}>
          {selectedType ? (
            <>
              {getReadableTypeName(selectedType)}
              <button className="type-reset-button" onClick={handleTypeResetClick}>✖</button>
            </>
          ) : (
            'Place Type'
          )}
        </span>
        <button className="dropdown-button">▼</button>
      </div>
      {isDropdownVisible && (
        <div className="dropdown-wrapper">
          <ul className="dropdown-list">
            {allTypes.map((type, index) => (
              <li
                key={index}
                className="dropdown-item"
                onMouseDown={() => handleTypeClick(type)}
              >
                {getReadableTypeName(type)}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

TypeFilter.propTypes = {
  savedPlaces: PropTypes.object.isRequired,
  selectedItinerary: PropTypes.object,
  onTypeFilterChange: PropTypes.func.isRequired,
};

export default TypeFilter;
